
<div class="wrapper">
  <app-header></app-header>
  <div class="fullscreen content">
    <div class="p-2 setscreen justify-content-center mt-custom">
      <!-- Left Sidebar -->
      <div class="col-md-4 d-none d-md-flex mt-4 justify-content-start">
        <div class="sidebar justify-content-center">
          <div class="leftsidess">Rent Agreement</div>

          <div class="step-wrapper">
            <div class="step-line"></div>
            <ul class="step-list">
              <li [class.active]="step === 1"><span class="circle"></span>
                Location/Rental Terms
              </li>
              <li [class.active]="step === 2"><span class="circle"></span>
                Owner Details</li>
              <li [class.active]="step === 3"><span class="circle"></span>
                Tenant Details</li>
            </ul>
          </div>

          <div class="progress-container">
            <div class="progress-circle-wrapper">
              <div
                class="progress-circle-foreground"
                [ngStyle]="{ 'background': getConicGradient() }">
              </div>
              <div class="progress-circle-text">{{ progress }}%</div>
            </div>

            <div class="progress-labels">
              <div class="progress-title">Progress score</div>
              <div class="progress-subtitle pl-md-3">Your progress so far</div>
            </div>
          </div>

        </div>
      </div>

      <!-- Right Form Panel -->
      <div class="col-md-6">
        <form [formGroup]="rentAgreementForm"
          (ngSubmit)="onSubmit()">
          <!-- Step 1 -->
          <div class="form-box" *ngIf="step === 1">
            <div class="leftside p-3"
              style="padding-top: 0px !important;">Property Location</div>
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label">Rental Property Address</label>
                <input type="text" class="form-control"
                  formControlName="propertyAddress"
                  placeholder="Rental Property Address">
                <div class="text-danger"
                  *ngIf="hasError('propertyAddress')">Rental Property Address is
                  required.</div>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Locality</label>
                <input type="text" class="form-control"
                  formControlName="propertyLocality" placeholder="Locality">
                <div class="text-danger"
                  *ngIf="hasError('propertyLocality')">Locality is
                  required.</div>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">City</label>
                <ng-select class="w-100" [items]="cityDataList" bindLabel="name"
                  bindValue="id"
                  placeholder="Select City" formControlName="propertyCityId"
                  (change)="onCityChange($event)"
                  (search)="onCitySearch($event)">
                </ng-select>
                <div class="text-danger" *ngIf="hasError('propertyCityId')">City
                  is required.</div>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">State</label>
                <ng-select class="w-100" [items]="stateDataList"
                  bindLabel="name" bindValue="id"
                  placeholder="Select State" formControlName="propertyStateId">
                </ng-select>
                <div class="text-danger"
                  *ngIf="hasError('propertyStateId')">State is required.</div>
              </div>
            </div>
            <div class="leftside p-3"
              style="padding-top: 10px !important;">Rental Terms</div>

            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label">Rent (Per Month)</label>
                <!-- <div class="input-group d-flex">
                  <span class="input-group-text">₹</span>
                  <input type="text" class="form-control"
                    formControlName="rentPerMonth" placeholder="Amount">
                </div> -->
                <div class="d-flex align-items-center gap-2">

                  <ng-select
                    class="mobile-code-select"
                    placeholder="₹ INR"
                    [clearable]="false"
                    [searchable]="false"
                    [disabled]="true"
                    style="min-width: 100px;">
                  </ng-select>

                  <input
                    type="text"
                    class="form-control mobile-number-input"
                    formControlName="rentPerMonth"
                    placeholder="Amount" (input)="onInput($event)" />
                </div>
                <div class="text-danger" *ngIf="hasError('rentPerMonth')">Rent
                  amount is required.</div>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Total Security</label>

                <div class="d-flex align-items-center gap-2">

                  <ng-select
                    class="mobile-code-select"
                    placeholder="₹ INR"
                    [clearable]="false"
                    [searchable]="false"
                    [disabled]="true"
                    style="min-width: 100px;">
                  </ng-select>

                  <input
                    type="text"
                    class="form-control mobile-number-input"
                    formControlName="totalSecurity"
                    placeholder="Amount" (input)="onInput($event)" />
                </div>
                <div class="text-danger" *ngIf="hasError('totalSecurity')">Total
                  security amount is required.</div>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Start Date</label>
                <input type="date" class="form-control"
                  formControlName="startDate">

                <div class="text-danger" *ngIf="hasError('startDate')">Start
                  date is required.</div>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">End Date</label>
                <input type="date" class="form-control"
                  formControlName="endDate">
                <div class="text-danger" *ngIf="hasError('endDate')">End date is
                  required.</div>
              </div>
            </div>
            <div class="d-flex justify-content-center mt-4" style="gap: 20px;">
              <!-- <button class="continue-btn" type="button"
                (click)="prevStep()">Back</button> -->
              <button class="continue-btn onlyhover" type="button"
                (click)="nextStep()">Continue</button>
            </div>
          </div>

          <!-- Step 2 -->
          <div class="form-box mt-3" *ngIf="step === 2">
            <div class="leftside p-3"
              style="padding-top: 0px !important;">Owner Details</div>
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label">Owner Name</label>
                <input type="text" class="form-control"
                  formControlName="ownerFullName"
                  placeholder="Name">
                <div class="text-danger" *ngIf="hasError('ownerFullName')">Owner
                  name is required.</div>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Father Name</label>
                <input type="text" class="form-control"
                  formControlName="ownerFatherName"
                  placeholder="Name">
                <div class="text-danger"
                  *ngIf="hasError('ownerFatherName')">Father's name is
                  required.</div>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Address</label>
                <input type="text" class="form-control"
                  formControlName="ownerAddress"
                  placeholder="Address">
                <div class="text-danger"
                  *ngIf="hasError('ownerAddress')">Address is required.</div>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Locality</label>
                <input type="text" class="form-control"
                  formControlName="ownerLocality"
                  placeholder="Locality">
                <div class="text-danger"
                  *ngIf="hasError('ownerLocality')">Locality is required.</div>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">City</label>
                <ng-select [items]="cityDataList1" bindLabel="name"
                  bindValue="id"
                  placeholder="Select City" formControlName="ownerCityId"
                  (change)="onCityChange1($event)"
                  (search)="onCitySearch1($event)">

                </ng-select>
                <div class="text-danger" *ngIf="hasError('ownerCityId')">City is
                  required.</div>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">State</label>
                <ng-select [items]="stateDataList" bindLabel="name"
                  bindValue="id"
                  placeholder="Select State" formControlName="ownerStateId">
                </ng-select>

                <div class="text-danger" *ngIf="hasError('ownerStateId')">State
                  is required.</div>
              </div>
              <!-- <div class="col-md-6 mb-3">
                                    <label class="form-label">Phone Number</label>
                                    <input type="tel" class="form-control" formControlName="ownerMobileNumber"
                                        placeholder="Number">
                                </div> -->
              <div class="col-md-6 mb-3">
                <label class="form-label">Phone Number</label>
                <div class="d-flex align-items-center gap-2">

                  <ng-select
                    class="mobile-code-select"
                    [items]="mobileCode"
                    bindLabel="phoneCode"
                    bindValue="phoneCode"
                    placeholder="+Code"
                    formControlName="ownerMobileCode"
                    style="min-width: 100px;">
                  </ng-select>
                  <input
                    type="text"
                    class="form-control mobile-number-input"
                    formControlName="ownerMobileNumber"
                    placeholder="Phone Number"
                    (input)="mobileonInput($event)" />

                </div>
                <div class="text-danger"
                  *ngIf="hasError('ownerMobileNumber')">Phone number is
                  required.</div>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Email</label>
                <input type="email"
                  formControlName="ownerEmail"
                  placeholder="Email Id">

                <div class="text-danger" *ngIf="hasError('ownerEmail')">Email is
                  required.</div>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Aadhar Card</label>
                <input type="text" class="form-control"
                  formControlName="ownerAadharNumber"
                  placeholder="Aadhar Card Number" (input)="adharInput($event)">
                <div class="text-danger"
                  *ngIf="hasError('ownerAadharNumber')">Aadhar number is
                  required.</div>
              </div>
              <div class="col-md-6 mb-3">

              </div>
            </div>
            <div class="d-flex justify-content-center mt-4" style="gap: 20px;">
              <button class="continue-btn onlyhover" type="button"
                (click)="prevStep()">Back</button>
              <button class="continue-btn onlyhover" type="button"
                (click)="nextStep()">Continue</button>
            </div>
          </div>
          <!-- Step 3 -->
          <div class="form-box" *ngIf="step === 3">
            <div class="leftside p-3"
              style="padding-top: 0px !important;">Tenant
              Details</div>
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label">Tenant Name</label>
                <input type="text" class="form-control"
                  formControlName="tenantFullName"
                  placeholder="Tenant name">
                <div class="text-danger"
                  *ngIf="hasError('tenantFullName')">Tenant name is
                  required.</div>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Father Name</label>
                <input type="text" class="form-control"
                  formControlName="tenantFatherName"
                  placeholder="Father Name">
                <div class="text-danger"
                  *ngIf="hasError('tenantFatherName')">Father name is
                  required.</div>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Address</label>
                <input type="text" class="form-control"
                  formControlName="tenantAddress"
                  placeholder="Address">
                <div class="text-danger"
                  *ngIf="hasError('tenantAddress')">Address is required.</div>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Locality</label>
                <input type="text" class="form-control"
                  formControlName="tenantLocality"
                  placeholder="Locality">
                <div class="text-danger"
                  *ngIf="hasError('tenantLocality')">Locality is required.</div>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">City</label>
                <ng-select [items]="cityDataList2" bindLabel="name"
                  bindValue="id"
                  placeholder="Select City" formControlName="tenantCityId"
                  (change)="onCityChange2($event)"
                  (search)="onCitySearch2($event)">
                </ng-select>
                <div class="text-danger" *ngIf="hasError('tenantCityId')">City
                  is required.</div>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">State</label>
                <ng-select [items]="stateDataList" bindLabel="name"
                  bindValue="id"
                  placeholder="Select State" formControlName="tenantStateId">
                </ng-select>
                <div class="text-danger" *ngIf="hasError('tenantStateId')">State
                  is required.</div>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Phone Number</label>
                <div class="d-flex align-items-center gap-2">

                  <ng-select
                    class="mobile-code-select"
                    [items]="mobileCode"
                    bindLabel="phoneCode"
                    bindValue="phoneCode"
                    placeholder="+Code"
                    formControlName="tenantMobileCode"
                    style="min-width: 100px;">
                  </ng-select>
                  <input
                    type="text"
                    class="form-control mobile-number-input"
                    formControlName="tenantMobileNumber"
                    placeholder="Phone Number"
                    (input)="mobileonInput($event)" />
                </div>

                <div class="text-danger"
                  *ngIf="hasError('tenantMobileNumber')">Phone number is
                  required.</div>
              </div>

              <div class="col-md-6 mb-3">
                <label class="form-label">Email</label>
                <input type="email" class="form-control"
                  formControlName="tenantEmail"
                  placeholder="Email Id">
                <div class="text-danger" *ngIf="hasError('tenantEmail')">Email
                  is required.</div>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Aadhar Card</label>
                <input type="text" class="form-control"
                  formControlName="tenantAadharNumber"
                  placeholder="Aadhar Card Number" (input)="adharInput($event)">
                <div class="text-danger"
                  *ngIf="hasError('tenantAadharNumber')">Aadhar Card is
                  required.</div>
              </div>
              <div class="col-md-6 mb-3">

              </div>
            </div>
            <div class="d-flex justify-content-center mt-4" style="gap: 20px;">
              <button class="continue-btn onlyhover" type="button"
                (click)="prevStep()">Back</button>
              <button class="continue-btn onlyhover" type="submit">Generate
                Agreement</button>
            </div>

          </div>

        </form>
      </div>
    </div>
    <br><br>

  </div>
  <app-footer></app-footer>
</div>
